// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"c95f3bb9","706":"43150af8"}[chunkId] + ".chunk.js";
};